import { render, staticRenderFns } from "./GuangzhouUnicom3.vue?vue&type=template&id=2fdd4959&scoped=true"
import script from "./GuangzhouUnicom3.vue?vue&type=script&lang=js"
export * from "./GuangzhouUnicom3.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouUnicom3.vue?vue&type=style&index=0&id=2fdd4959&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd4959",
  null
  
)

export default component.exports